var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyIconFullGray = function SvgCompanyIconFullGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    fillRule: "evenodd",
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v7.833h-.833a.5.5 0 0 0 0 1h13.666a.5.5 0 1 0 0-1H14v-5a2.5 2.5 0 0 0-2.5-2.5h-.833v7.5H10V4.5A2.5 2.5 0 0 0 7.5 2zm.667 3.333a.5.5 0 0 0 0 1h1.666a.5.5 0 0 0 0-1zm0 2.667a.5.5 0 0 0 0 1h1.666a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
};
export { SvgCompanyIconFullGray as ReactComponent };
export default __webpack_public_path__ + "0f9361e10950a022a692a74a37fb92be.svg";